import * as React from 'react';
import styled from 'styled-components';

import { spin } from '../../utils/theme/themes';

const Wrapper = styled.div`
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${({ theme }) => theme.backgroundColor};
`;

const Inner = styled.div`
  animation: ${spin} 2s linear infinite;
  width: 16px;
  height: 16px;
  svg {
    color: ${({ theme }) => theme.highlightColor};
  }
`;

export const Spinner: React.ComponentType = React.memo(() => {
  return (
    <Wrapper>
      <Inner>
        <svg
          fill="none"
          height="16"
          viewBox="0 0 16 16"
          width="16"
          xmlns="http://www.w3.org/2000/svg">
          <g>
            <circle cx="8" cy="2" r="1.5" stroke="currentColor" />
            <circle cx="8" cy="14" r="1.5" stroke="currentColor" />
            <circle cx="3" cy="11" r="1.5" stroke="currentColor" />
            <circle cx="3" cy="5" r="1.5" stroke="currentColor" />
            <circle cx="13" cy="11" r="1.5" stroke="currentColor" />
            <circle cx="13" cy="5" r="1.5" stroke="currentColor" />
          </g>
        </svg>
      </Inner>
    </Wrapper>
  );
});
